import React, { HTMLProps, PropsWithChildren } from 'react';
import { Icon } from '@geberit/gdds';
import type { UrlObject } from 'url';

import { StyledLink } from './nav-item.styles';

type NavItemProps = PropsWithChildren<{
  href: UrlObject | string;
  isOption?: boolean;
  selected?: boolean;
  shallow?: boolean;
  leftIconUrl?: string | false;
  leftIconName?: string | false;
  rightIconName?: string | false;
  hasPictogram?: boolean;
  withPictogram?: boolean;
  firstLevel?: boolean;
  thirdLevel?: boolean;
  isOverviewItem?: boolean;
  notClickable?: boolean;
}> &
  HTMLProps<HTMLAnchorElement>;

export function SecondLevelNavItem({
  selected,
  leftIconUrl,
  leftIconName,
  rightIconName,
  hasPictogram,
  withPictogram,
  firstLevel,
  thirdLevel,
  shallow,
  children,
  isOption,
  as,
  isOverviewItem,
  notClickable,
  ...anchorProps
}: NavItemProps) {
  function getIconPosition() {
    if ((leftIconName || leftIconUrl) && rightIconName) {
      return 'both';
    }
    if (leftIconName || leftIconUrl) {
      return 'left';
    }
    if (rightIconName) {
      return 'right';
    }
    return 'none';
  }

  return (
    <StyledLink
      className={selected ? 'selected' : undefined}
      selected={selected}
      $notClickable={notClickable}
      shallow={shallow}
      $isOption={isOption}
      $iconPosition={getIconPosition()}
      $hasPictogram={withPictogram && !isOverviewItem}
      $firstLevel={firstLevel}
      $thirdLevel={thirdLevel}
      $isOverviewItem={isOverviewItem}
      {...anchorProps}
    >
      {leftIconUrl && <img src={leftIconUrl} alt="" />}
      {children}
      {rightIconName && <Icon className="last-icon" symbol={rightIconName} />}
    </StyledLink>
  );
}
